module.exports = __webpack_public_path__ + "img/main_kitchenl.fb2b285b.png";